import { commandPost, toastOk, toastError } from "@/lib/commands/api";
import { AssignDriverPanel } from "@/components/command-bar/panels/assign-driver-panel";
import type { Command } from "@/lib/commands/types";

// Dispatch commands operate on a Load. They're scoped to
// load_detail so neither the hotkey nor the palette entry fires
// without a load id in the URL.
export const commandsDispatch: Command[] = [
  {
    id: "load.assign_driver",
    label: "Assign driver to load",
    description: "Pick a driver from your fleet or overflow to Curri.",
    group: "load",
    scope: "load_detail",
    hotkey: { mod: ["mod"], key: "a" },
    permission: "org:dispatch:write",
    handler: { kind: "panel", open: AssignDriverPanel },
  },
  {
    id: "load.unassign_driver",
    label: "Unassign driver",
    group: "load",
    scope: "load_detail",
    permission: "org:dispatch:write",
    confirmation: {
      title: "Unassign driver?",
      destructive: true,
      body: "The load returns to the unassigned queue.",
    },
    handler: {
      kind: "mutation",
      run: async (ctx) => {
        try {
          await commandPost(`/api/v1/dispatch/unassign`, { load_id: ctx.loadId });
          toastOk("Driver unassigned");
        } catch (e) {
          toastError(e instanceof Error ? e.message : "Failed to unassign");
          throw e;
        }
      },
    },
  },
  {
    id: "load.cancel",
    label: "Cancel load",
    group: "load",
    scope: "load_detail",
    permission: "org:loads:cancel",
    confirmation: {
      title: "Cancel this load?",
      destructive: true,
      body: "This cannot be undone. Pending offers will be revoked.",
      confirmLabel: "Cancel load",
    },
    handler: {
      kind: "mutation",
      run: async (ctx) => {
        try {
          await commandPost(`/api/v1/loads/${ctx.loadId}/cancel`);
          toastOk("Load cancelled");
        } catch (e) {
          toastError(e instanceof Error ? e.message : "Failed to cancel");
          throw e;
        }
      },
    },
  },
];
